import Logo from '../images/logo.png'
import Bar from '../images/nav/btn_ginasbar.png'
import Explorer from '../images/nav/btn_explorer.png'
import Team from '../images/nav/btn_team.png'
import Treasure from '../images/nav/btn_treasure.png'
import Itemshop from '../images/nav/btn_itemshop.png'
import Announcement from '../images/nav/btn_announcement.png'


export default function Navigation() {
  return (
    <>
      <nav className="navigation">
        <h1><img src={Logo} alt='Isekai Battle' /></h1>

        <ul className='navigation__tab'>
          <li>
            <button>
              <img src={Bar} alt="Gina's Bar" className='navigation__bar' />
            </button>
          </li>
          <li>
            <button>
              <img src={Explorer} alt="Explorer" />
            </button>
          </li>
          <li>
            <button>
              <img src={Team} alt="Team" />
            </button>
          </li>
          <li>
            <button>
              <img src={Treasure} alt="Treasure" />
            </button>
          </li>
          <li>
            <button>
              <img src={Itemshop} alt="Item Shop" />
            </button>
          </li>
          <li>
            <button>
              <img src={Announcement} alt="Announcement" />
            </button>
          </li>
        </ul>
      </nav>
    </>
  );
}

